import { IUserStatusViewModel } from "interfaces/models/IUserStatusViewModel";

const StatusTemplate = ({ status }: IUserStatusViewModel) => (<span data-testid="status" className="title">{status}</span>);

export default StatusTemplate;
